import "../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { ArticulosContext } from '../../../context/articulos/ArticulosContext';
import { useNavigate, Link } from 'react-router-dom';
import { Paginator } from '../../../components/paginator/Paginator';
import { getHeaders } from "./configGrid/headers";
import { formatRows } from "./configGrid//rows";
import { indice } from "../../../components/DataGrid/indice";
import { getActionColumn } from "../../../components/ActionesColumns/ActionColumns";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import useDocumentTitle from '../../../components/Title';
import CustomDataGrid from "../../../components/DataGrid/CustomDataGrid";
import ConfirmDialog from "../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDeleteDialog";
import { fetchEntityData, deleteItem } from './configGrid/apiCalls';
import FiltersGrid from './filtersGrid/filtersGrid';
import { useFilters } from "../../../context/FiltersContext";

export const Datatable = ({
  onSelect,
  onClose,
  tipoprecio,
  findNoCombo = false,
  findStock = false,
  enableCreate = true,
  disableSelection,
  enableCheckboxSelection,
  enableSelectionClick,
  enableSelectionFinder,
  tipovista = "completo" , 
}) => {
  const titleGrid = "Lista de Articulos"
  useDocumentTitle(titleGrid);
const { updateFilters, getFilters } = useFilters();
  const contexto = useContext(ArticulosContext);
  const {
    deleteArticuloData,
    getArticulosPanelData,
    getArtNoCombosPanelData,
    getArticulosExistenciaPanelData
  } = contexto;
  const navigate = useNavigate();
  const nameData = "articulos";
  const getData = findStock
    ? getArticulosExistenciaPanelData
    : findNoCombo
      ? getArtNoCombosPanelData
      : getArticulosPanelData;
  const deleteData = deleteArticuloData;

  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Estado del buscador
  const [searchTerm, setSearchTerm] = useState("");
  const searchSelectRef = useRef();
  const [searchIDRam, setSearchIDRam] = useState();
  const [searchIDRub, setSearchIDRub] = useState();
  const [searchIDSubr, setSearchIDSubr] = useState();
  const [searchIDMar, setSearchIDMar] = useState();
  const [searchDescRam, setSearchDescRam] = useState();
  const [searchDescRub, setSearchDescRub] = useState();
  const [searchDescSubr, setSearchDescSubr] = useState();
  const [searchDescMar, setSearchDescMar] = useState();
  const [searchDes, setSearchDes] = useState();
  // Ref de input
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Estado para el modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Estado para manejar el error
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);

 //Estado General de Filtros en LocalStorage
  const [isInitialized, setIsInitialized] = useState(false);
  const pageKey = "articulos";
  // 🔹 Obtenemos los filtros persistidos
  const filters = getFilters(pageKey) || {
    searchTerm: "",
    searchIDRam: "",
    searchDescRam: "",
    searchIDRub: "",
    searchDescRub: "",
    searchIDSubr: "",
    searchDescSubr: "",
    searchIDMar: "",
    searchDescMar: "",
    searchDes: "",
  };

  useEffect(() => {
    const savedFilters = getFilters(pageKey);

    if (savedFilters) {
      setSearchTerm(savedFilters.searchTerm || "");
      setSearchIDRam(savedFilters.searchIDRam || "");
      setSearchDescRam(savedFilters.searchDescRam || "");
      setSearchIDRub(savedFilters.searchIDRub || "");
      setSearchDescRub(savedFilters.searchDescRub || "");
      setSearchIDSubr(savedFilters.searchIDSubr || "");
      setSearchDescSubr(savedFilters.searchDescSubr || "");
      setSearchIDMar(savedFilters.searchIDMar || "");
      setSearchDescMar(savedFilters.searchDescMar || "");
      setSearchDes(savedFilters.searchDes || "");
      setNumPagina(savedFilters.numPagina || 1);
    }

    setIsInitialized(true);
  }, []);

  useEffect(() => {
    if (!isInitialized) return;
    fetchData();
    loadFilters();
  }, [isInitialized, searchTerm, searchIDRam, searchDescRam, searchIDRub, searchDescRub, searchIDSubr, searchDescSubr, searchIDMar, searchDescMar, searchDes, numPagina, filas]);

  // 🔹 Función segura para actualizar filtros
  const loadFilters = () => {
    const updatedFilters = {
      searchTerm,
      searchIDRam,
      searchDescRam,
      searchIDRub,
      searchDescRub,
      searchIDSubr,
      searchDescSubr,
      searchIDMar,
      searchDescMar,
      searchDes
    };
    updateFilters(pageKey, updatedFilters);
  };

  // Dentro del componente `Datatable`
  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const { dataEntity, totalItems, totalPage, totalDataItems } = await fetchEntityData(
        getData,
        searchTerm,
        searchIDRam,
        searchIDRub,
        searchIDSubr,
        searchIDMar,
        searchDes,
        numPagina,
        filas,
        findNoCombo
      );

      if (numPagina > totalPage) {
        setNumPagina(totalPage);
      } else {
        setListaItems(dataEntity);
        setTotalItems(totalItems);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleDelete = async () => {
    try {
      await deleteItem(deleteData, selectedItem);
      fetchData(); // Refresca los datos
      closeModal(); // Cierra el modal de confirmación
    } catch (error) {
      console.error(error);
      setErrorMessage("No se pudo eliminar el elemento. Inténtalo nuevamente.");
      setIsErrorDialogOpen(true);
    }
  };

  const closeErrorDialog = () => {
    setErrorMessage(""); // Limpia el mensaje de error
    setIsErrorDialogOpen(false); // Cierra el diálogo de error
  };

  const openModal = (id) => {
    setSelectedItem(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const handleDesChange = (e) => {
    const value = e.target.value;
    setSearchDes(value === "1" ? "Sí" : "No"); // Cambia el valor a "Sí" o "No"
  };


  const handleClickEdit = (e) => {
    if (e) navigate(`/${nameData}/new/${e}`);
  };

  const handleSearch = () => {
    const value = searchInputRef.current?.value || ""; // Obtiene el valor del input
    setSearchTerm(value); // Actualiza el estado con el término de búsqueda
  };

  const handleClear = () => {
    setSearchTerm("");
    if (searchInputRef.current) {
      searchInputRef.current.value = ""; // Limpia el input de búsqueda
    }
  };

  const handleClearDes = () => {
    setSearchDes("");
    if (searchSelectRef.current) {
      searchSelectRef.current.value = ""; // Limpia el input de búsqueda
    }
  };

  const handleRowClick = (params) => {
    const selectedId = params.row.id; // Capturar el id del Cliente
    const selectedCod = params.row.codigo;
    const selectedDesc = params.row.descripcion;
    const selectedCos = params.row.preciocosto;
    const selectedMay = params.row.preciomayorista;
    const selectedMin = params.row.preciominorista;
    onSelect && onSelect(selectedId, selectedDesc, selectedCod, selectedCos, selectedMay, selectedMin); // Devolver el id y descripción al componente padre
    onClose && onClose(); // Cerrar el modal después de la selección
  };

  const headersArt = getHeaders(tipovista).filter((column) => {
    if (Number(tipoprecio) === 0 && (column.field === "preciominorista" || column.field === "preciocosto")) {
      return false; // Oculta P. Minorista y P. Costo para tipo precio 0
    }
    if (Number(tipoprecio) === 1 && (column.field === "preciomayorista" || column.field === "preciocosto")) {
      return false; // Oculta P. Mayorista y P. Costo para tipo precio 1
    }
    return true; // Muestra las demás columnas
  });

  // Dentro de la función Datatable...
  const datosColum = useMemo(() => {
    const commonCols = indice(numPagina, filas).concat(headersArt.filter((column) => !column.hidden));
    return onSelect ? commonCols : commonCols.concat(getActionColumn(handleClickEdit, openModal));
  }, [onSelect, numPagina, filas]);

  const rows = useMemo(() => formatRows(listaItems, tipovista), [listaItems]);
  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectionChange = (selectedIds) => {
    setSelectedItems(selectedIds);
  };

  const handleConfirmSelection = (selectedRows) => {
    onSelect && onSelect(selectedRows); // Devolver el id y descripción al componente padre
    onClose && onClose(); // Cerrar el modal después de la selección
  };
  const onConfirmSelection = (selectedRows) => {
    onSelect && onSelect(selectedRows); // Devolver el id y descripción al componente padre
    onClose && onClose(); // Cerrar el modal después de la selección
  };

  return (
    <div className="datatable">
      <div className="datatableTitle" >
        <h3>{titleGrid}</h3>
         {
          enableCreate &&
          <div className="linkContainer">
            <Link to={`/${nameData}/new`} className="link">Agregar</Link>
          </div>
        }
        <FiltersGrid
          searchInputRef={searchInputRef}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          onSearch={handleSearch}
          onClose={handleClear}
          setSearchIDMar={setSearchIDMar}
          setSearchDescMar={setSearchDescMar}
          setSearchIDRam={setSearchIDRam}
          setSearchDescRam={setSearchDescRam}
          setSearchIDRub={setSearchIDRub}
          setSearchDescRub={setSearchDescRub}
          setSearchIDSubr={setSearchIDSubr}
          setSearchDescSubr={setSearchDescSubr}
          searchIDRam={searchIDRam}
          searchIDRub={searchIDRub}
          searchSelectRef={searchSelectRef}
          searchDes={searchDes}
          handleDesChange={handleDesChange}
          handleClearDes={handleClearDes}
        />
       

      </div>

      {(isLoading) ? (
        <div className="loading">
          <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
            <h1>Cargando datos...</h1>
            <CircularProgress />
          </div>
        </div>
      ) : (
        <>
          <div className="datagridWrapper">
            <CustomDataGrid
              rows={rows}
              columns={datosColum}
              pageSize={filas}
              rowCount={totalItems}
              onRowClick={handleRowClick}
              onSelectionChange={handleSelectionChange}
              onConfirmSelection={handleConfirmSelection}
              onPageChange={setNumPagina}
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1);
              }}
              isLoading={isLoading}
              disableSelection={disableSelection}
              enableCheckboxSelection={enableCheckboxSelection}
              enableSelectionFinder={enableSelectionFinder}
              enableSelectionClick={enableSelectionClick}
            />
          </div>

          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalItems}
            />
          </div>

          <ConfirmDialog
            open={isModalOpen}
            onClose={closeModal}
            onConfirm={handleDelete}
            nameData={nameData}
          />

          <ErrorDialog
            open={isErrorDialogOpen}
            onClose={closeErrorDialog}
            errormessages={errorMessage}
          />
        </>
      )}
    </div>

  );
};
Datatable.propTypes = {
  onSelect: PropTypes.func,
  onClose: PropTypes.func,
  tipoprecio: PropTypes.number,
};
Datatable.defaultProps = {
  tipoprecio: 2,
};
export default Datatable;
